/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverwolfXPTransactionGame } from './OverwolfXPTransactionGame';
import {
    OverwolfXPTransactionGameFromJSON,
    OverwolfXPTransactionGameFromJSONTyped,
    OverwolfXPTransactionGameToJSON,
    OverwolfXPTransactionGameToJSONTyped,
} from './OverwolfXPTransactionGame';
import type { AccountExperienceTransactionType } from './AccountExperienceTransactionType';
import {
    AccountExperienceTransactionTypeFromJSON,
    AccountExperienceTransactionTypeFromJSONTyped,
    AccountExperienceTransactionTypeToJSON,
    AccountExperienceTransactionTypeToJSONTyped,
} from './AccountExperienceTransactionType';
import type { AccountExperienceTransactionSubject } from './AccountExperienceTransactionSubject';
import {
    AccountExperienceTransactionSubjectFromJSON,
    AccountExperienceTransactionSubjectFromJSONTyped,
    AccountExperienceTransactionSubjectToJSON,
    AccountExperienceTransactionSubjectToJSONTyped,
} from './AccountExperienceTransactionSubject';

/**
 * 
 * @export
 * @interface OverwolfXPTransaction
 */
export interface OverwolfXPTransaction {
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OverwolfXPTransaction
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OverwolfXPTransaction
     */
    updatedAt: number;
    /**
     * 
     * @type {AccountExperienceTransactionSubject}
     * @memberof OverwolfXPTransaction
     */
    subject: AccountExperienceTransactionSubject;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    user: string;
    /**
     * 
     * @type {AccountExperienceTransactionType}
     * @memberof OverwolfXPTransaction
     */
    type: AccountExperienceTransactionType;
    /**
     * 
     * @type {number}
     * @memberof OverwolfXPTransaction
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    community?: string;
    /**
     * The ID of the Overwolf reward that triggered this transaction.
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    overwolfRewardId?: string;
    /**
     * The ID of the guild quest that triggered this transaction.
     * @type {string}
     * @memberof OverwolfXPTransaction
     */
    guildQuestId?: string;
    /**
     * A list of games associated with the XP transaction.
     * @type {Array<OverwolfXPTransactionGame>}
     * @memberof OverwolfXPTransaction
     */
    games?: Array<OverwolfXPTransactionGame>;
}



/**
 * Check if a given object implements the OverwolfXPTransaction interface.
 */
export function instanceOfOverwolfXPTransaction(value: object): value is OverwolfXPTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function OverwolfXPTransactionFromJSON(json: any): OverwolfXPTransaction {
    return OverwolfXPTransactionFromJSONTyped(json, false);
}

export function OverwolfXPTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverwolfXPTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'subject': AccountExperienceTransactionSubjectFromJSON(json['subject']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
        'user': json['user'],
        'type': AccountExperienceTransactionTypeFromJSON(json['type']),
        'amount': json['amount'],
        'community': json['community'] == null ? undefined : json['community'],
        'overwolfRewardId': json['overwolfRewardId'] == null ? undefined : json['overwolfRewardId'],
        'guildQuestId': json['guildQuestId'] == null ? undefined : json['guildQuestId'],
        'games': json['games'] == null ? undefined : ((json['games'] as Array<any>).map(OverwolfXPTransactionGameFromJSON)),
    };
}

export function OverwolfXPTransactionToJSON(json: any): OverwolfXPTransaction {
    return OverwolfXPTransactionToJSONTyped(json, false);
}

export function OverwolfXPTransactionToJSONTyped(value?: OverwolfXPTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'subject': AccountExperienceTransactionSubjectToJSON(value['subject']),
        'notes': value['notes'],
        'adminNotes': value['adminNotes'],
        'user': value['user'],
        'type': AccountExperienceTransactionTypeToJSON(value['type']),
        'amount': value['amount'],
        'community': value['community'],
        'overwolfRewardId': value['overwolfRewardId'],
        'guildQuestId': value['guildQuestId'],
        'games': value['games'] == null ? undefined : ((value['games'] as Array<any>).map(OverwolfXPTransactionGameToJSON)),
    };
}

